export default __webpack_public_path__ + "media/vendors/app_store_download-56a9ebc1.svg";